// Default value of Orion settings.
export const defaultSettings = {
  enable_fuzzy_public_search: false, // When true, the public (clip) search will use fuzzy matching.
  hide_storage_banner_video_page: false,
  postpone_age_verification: false, // When true, age verification happens only when attempting to watch non-safe content.
  onboarding_survey_kind: 'legacy_registration' as 'legacy_registration' | 'bsp_onboarding',
  onboarding_survey_skip_to_paywall: false,
  onboarding_paywall_kind: 'legacy' as 'legacy' | 'plansComparison' | 'featureList',
  onboarding_paywall_tier: 'starter' as 'starter' | 'standard' | 'advanced',
  onboarding_paywall_default_periodicity: 'yearly' as 'yearly' | 'monthly',
  onboarding_paywall_monthly_free_trial: false,
  onboarding_paywall_dismiss_button_position: 'top_right' as 'top_right' | 'bottom',
  late_stage_paywall_kind: 'legacy' as
    | 'legacy'
    | 'limit_based_bsp'
    | 'limits_only_bsp'
    | 'bsp_cards_generic_and_bsp_limits'
    | 'bsp_table_generic_and_bsp_limits',
  limit_based_paywall_tier: 'one_up' as
    | 'one_up'
    | 'standard'
    | 'advanced'
    | 'creator'
    | 'professional',
  campaign_id_override: 'null' as 'null' | 'pi_2026' | CampaignIdOverride,
  should_show_add_to_showcase_folder: false,
  should_limit_showcase_folder_add: true,
  review_generic_comment_timecode: false,
  review_accountless_comment_redesign: false,
  checkout_experience: 'legacy' as 'legacy' | 'disclosureVisiblePrice',
  orion_free_override: false, // When true, users get REPACK_FREE product instead of default free tier.
  enable_new_library_drag_and_drop_upload: false,
  add_to_folders_modal_select_all_folders: false,
  showcase_autoplay_video_preview: false,
  enable_no_expiration_review_link_option: false,
  bi_fake_door_expired_share_link_enabled: false,
  bsp_cancellation_flow: false,
  use_resource_name_for_review_links: false,
  enable_review_link_default_settings: false,
  enable_review_link_end_cards: false,
  enable_downgrade_flow: false,
  show_profile_reorder_modal: false,
  show_downgrade_card_billing: false,
  enable_rename_folder: false,
  enable_rename_video: false,
  enable_copy_button_showcase: false,
  enable_rename_showcase_and_events: false,
  enable_privacy_badge_modal: false,
  enable_review_page_shortcut_from_main: false,
  enable_profile_hover_video_preview: false,
  is_new_live_events_dashboard_enabled: false,
  creator_monetisation_creator_enabled: false,
  creator_monetisation_viewer_treatment: 'false' as 'false' | 'donation' | 'subscription',
  mweb_to_app_redirect: 'control' as 'control' | 'smart_banner' | 'custom_modal',
  enable_viewer_home_suggestions_api: false,
  enable_billing_menu_item: false,
  auto_select_uploaded_thumbnail: false,
  viewer_home_closed_captions_fake_door_enabled: false,
  viewer_home_playback_speed_fake_door_enabled: false,
  viewer_home_transcript_fake_door_enabled: false,
  viewer_home_resolution_fake_door_enabled: false,
  viewer_home_fake_door_checkout_trial_enabled: true,
  viewer_home_playback_paywall: 'none' as 'none' | 'soft' | 'hard',
  free_trial_banner_tier: 'none' as 'none' | 'low_tier' | 'mid_tier' | 'high_tier',
  show_trial_renewal_date_in_billing_card: false,
  enable_review_link_submenu: false,
  should_switch_to_repackaging_free: false,
  should_switch_to_higher_storage_free: false,
  should_have_permissive_review_links: false,
  enable_seat_changes_for_tiered: false,
  upload_max_simultaneous_uploads: 1,
  enable_omnisearch_folder_scoped_request_fix: false,
  enable_showcase_search: false,
  enable_uploader_tooltip: false,
  viewer_ai_upsell_modal_enabled: false,
  profile_redesign: false,
  enable_avatar_initials_fallback: false,
  enable_list_view_folder_upload: false,
  enable_cold_storage_library_ux: false,
  remove_watermark_free_tier: false,
  maximize_video_file_transfer_adoption: false,
  maximize_review_adoption: false,
  enable_single_video_rendition_status: false,
  hp_recents_number_of_videos: 10,
  hp_recents_single_fetch: false,
  enable_hp_recents_items_prefetch: false,
  hp_remove_search_params_results: false,
} as const;

export type CampaignIdOverride =
  | 'pi_2026_storage_seat'
  | 'pi_2026_legacy_plans'
  | 'rp_2026'
  | 'rp_2026_strict';

/// Type of the Orion settings.
export type OrionSettings = typeof defaultSettings;
